import { createConfigSelector } from '@americanexpress/travel-selectors';
import { createSelector } from 'reselect';
import { getLang } from '@/helpers/utils';
import { getLocaleData } from './localeSelectors';

export const getBdaasUrl = createConfigSelector('bdaasUrl');

export const getBdaasLoungeFinderBaseUrl = createSelector(
  getBdaasUrl,
  (bdaasUrl) => `${bdaasUrl}/api/lounge_finder`
);

// needed temporarily for the argentina centurion card until THE_CENTURION_CARD_ES_AR is added to BDAAS
export function getProduct(product, locale) {
  // needed for temporarily for the card switcher page (no product in url)
  if (!product) {
    return 'the-platinum-card';
  }

  if (product === 'the-centurion-card' && locale === 'es-AR') {
    return 'the-centurion-card-argentina';
  }
  return product;
}

export const getBdaasAirportsUrl = (product) => (state) => {
  const { locale } = getLocaleData(state);
  const baseUrl = getBdaasLoungeFinderBaseUrl(state);
  return `${baseUrl}/airports?product=${getProduct(product, locale)}&locale=${locale}&lang=${getLang(
    locale
  )}`;
};

export const getBdaasAirportLoungesUrl = ({ product, airportCode }) =>
  createSelector(
    getBdaasLoungeFinderBaseUrl,
    getLocaleData,
    (baseUrl, { locale }) =>
      `${baseUrl}/airports/${airportCode}/lounges?product=${getProduct(product, locale)}&locale=${locale}&lang=${getLang(
        locale
      )}`
  );
